import { topRankList } from "@/mocks/manhwa";

const medalColors = ["bg-primary-500", "bg-primary-400", "bg-secondary-500"];

export default function TopRank() {
  return (
    <section id="ranking" className="relative mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
            <i className="ri-trophy-line"></i> 每周更新
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
            好看的韩国漫画排行榜 <span className="text-primary-600">TOP 10</span>
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            综合读者评分、阅读热度与完读率排出的本周必看榜单，从高分神作到人气爆款一网打尽，每一部都值得你停下来认真追。
          </p>
        </div>
        <p className="whitespace-nowrap rounded-lg border border-background-200 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700">
          更新于 2026 年第 34 周
        </p>
      </div>

      <div className="mt-10 grid gap-4 lg:grid-cols-2">
        {topRankList.map((item) => {
          const isTop = item.rank <= 3;
          return (
            <article
              key={item.rank}
              className="group flex items-start gap-4 rounded-2xl border border-background-200/80 bg-background-100/60 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:gap-5 md:p-5"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl font-heading text-xl font-black ${
                  isTop ? `${medalColors[item.rank - 1]} text-background-50` : "bg-background-200 text-foreground-700"
                }`}
              >
                {item.rank}
              </span>

              <a href="#ranking" className="block shrink-0" aria-label={`${item.title}封面`}>
                <img
                  src={item.cover}
                  alt={`${item.title} 韩国漫画封面`}
                  className="h-28 w-20 rounded-lg object-cover object-top transition-transform duration-300 group-hover:-translate-y-1 md:h-32 md:w-[92px]"
                />
              </a>

              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-900 md:text-lg">
                    {item.title}
                  </h3>
                  <span className="whitespace-nowrap font-heading text-lg font-black text-primary-600">
                    {item.score.toFixed(1)}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {item.author} · {item.genre}
                </p>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-700 md:text-sm">
                  {item.desc}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}